// extracted by mini-css-extract-plugin
module.exports = {"contents":"Lm-z","sectionHeading":"Mm-z"};